import {
  ButtonV3,
  GridItem,
  LayoutGrid,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';

import ArtDirectionImage from '@/app/components/Image/ArtDirectionImage';
import RichText from '@/app/components/RichText';

const tValues = {
  i: (chunks: ReactNode) => <em className="font-serif italic">{chunks}</em>,
};

const Hero = () => {
  const t = useTranslations();
  return (
    <section data-cy="developer-hero">
      <LayoutGrid>
        <GridItem
          className="relative h-svh"
          colEnd={{ sm: 'full' }}
          colStart={{ sm: 'full' }}
          rowEnd={{ sm: 2 }}
          rowStart={{ sm: 1 }}
        >
          <ArtDirectionImage
            fill
            priority
            sizes="100vw"
            alt=""
            className="object-cover"
            srcSet={[
              {
                src: 'developer/developer-hero-mobile',
                media: '(max-width: 1199px)',
              },
              {
                src: 'developer/developer-hero-desktop',
                media: '(min-width: 1200px)',
              },
            ]}
          />
        </GridItem>
        <GridItem
          className="relative flex flex-col pt-28 md:justify-center md:pt-0"
          colEnd={{ sm: 'main', md: 13, lg: 12 }}
          colStart={{ sm: 'main' }}
          rowEnd={{ sm: 2 }}
          rowStart={{ sm: 1 }}
        >
          <TypographyV3
            align="centerMdLeft"
            Element="h1"
            variant="h1"
            height="tight"
            color="light"
            className="mb-2"
          >
            <RichText messageKey="developer_hero_title" tValues={tValues} />
          </TypographyV3>
          <TypographyV3
            align="centerMdLeft"
            Element="h2"
            variant="h6"
            color="light"
            className="mb-2"
          >
            {t('developer_hero_body')}
          </TypographyV3>
          <div className="mx-auto mt-6 md:mx-0">
            <ButtonV3
              variant="secondary-light"
              href="https://cloud.ouraring.com/v2/docs"
              target="_blank"
              rel="noreferrer"
            >
              {t('developer_hero_cta')}
            </ButtonV3>
          </div>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default Hero;
